import React from 'react';
import Component from '@vfuk/core-grouped-text-input';
const GroupedTextInput = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default GroupedTextInput;
